export const debounce = (callback: (...params: unknown[]) => unknown, wait: number): (...params: unknown[]) => unknown => {
  let timeout: number
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => { callback.apply(this, args) }, wait)
  }
}
